// calculators/true-cost/src/index.ts
// Entry point. Bundled to /calculators/true-cost/bundle.js.
// Waits for i18nReady (so t() returns translated strings) then wires up DOM.

import { attachCalculator } from "./calculator";

function start(): void {
  attachCalculator();
}

const w = window as unknown as { i18nReady?: Promise<unknown> };

function whenReady(): void {
  if (w.i18nReady && typeof w.i18nReady.then === "function") {
    let attached = false;
    const safeStart = (): void => {
      if (attached) return;
      attached = true;
      start();
    };
    w.i18nReady.then(safeStart).catch(safeStart);
    // Fallback: don't let a hanging i18n promise leave the calculator dead.
    // 1500ms is well past i18next's typical init time but short enough that
    // a user who's fast on the trigger gets a working button before clicking.
    setTimeout(safeStart, 1500);
  } else {
    start();
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", whenReady);
} else {
  whenReady();
}
